import {
  AdvancedImage,
  lazyload,
  placeholder,
  responsive,
} from '@cloudinary/react';
import { CloudinaryImage } from '@cloudinary/url-gen';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { getVideoKategoria } from '../../api/video';
import Subscriptions from '../../components/subscriptions/activeSubscriptions';
import VideoKategoria from '../../components/video/video-kategoria/VideoKategoria';
import { useAuth } from '../../contexts/auth';

export default function Home() {
  const [kategoria, setKategoria] = useState([]);
  const [displaySubscriptionBoxes, toggleSubscriptions] = useState(true);
  const navigate = useNavigate();
  const logo = new CloudinaryImage('tanyaegyetem/TE_logo_transparent', {
    cloudName: 'scriptantia',
  });
  const { user, signOut } = useAuth();

  useEffect(() => {
    getVideoKategoria().then(setKategoria);
    if (!user) {
      navigate('/logout');
    } else {
      if (user.activeSubscriptions.length === 0) {
        navigate('/subscribe');
      }
    }
  }, []);

  return (
    <Box
      p={8}
      sx={{
        width: '100%', // A kis képernyőkön ne legyen probléma
        margin: '0 auto', // Középre igazítja az egész tartalmat
        p: 4, // Egy kicsit csökkentett padding
      }}
    >
      <Typography variant='h4' gutterBottom>
        Szia {user.userData.user.firstName}!
      </Typography>

      <Card
        sx={{
          textAlign: 'center',
          p: 3,
          mb: 3,
        }}
      >
        <CardContent>
          <AdvancedImage
            cldImg={logo}
            plugins={[
              lazyload(),
              responsive({ steps: [100, 200, 300] }),
              placeholder(),
            ]}
          />
        </CardContent>
      </Card>

      {user.activeSubscriptions.length !== 0 ? (
        <>
          <Box>
            <Box display='flex' justifyContent='center' my={2}>
              <ReactPlayer
                width='100%'
                height='100%'
                url='https://vimeo.com/817427820'
                controls
              />
            </Box>
            <Typography variant='body1' textAlign='justify' my={2}>
              Szeretettel köszöntünk a Tanya Egyetem hallgatói között! Ez a
              tudástár egyedülálló, mert a magyarországi környezeti
              adottságokban működő, paraszti hagyományból megmaradt, de egyre
              inkább kivesző tudásanyagot tárja eléd.
            </Typography>
          </Box>
          <Box
            display='flex'
            flexWrap='wrap'
            justifyContent='center'
            mt={3}
            gap={2}
          >
            {kategoria.length > 0 ? (
              kategoria.map((vk) => (
                <Card
                  key={vk.kategoriaId}
                  sx={{ width: 300, textAlign: 'center' }}
                >
                  <CardContent>
                    <VideoKategoria
                      katKey={vk.kategoriaId}
                      kategoriaNev={vk.kategoriaNev}
                      cldImageName={vk.cldImageName}
                    />
                  </CardContent>
                </Card>
              ))
            ) : (
              <CircularProgress />
            )}
          </Box>
        </>
      ) : (
        <Box textAlign='center' my={3}>
          <Typography variant='body1'>
            Még nincs előfizetésed. A videók megtekintéséhez fizess elő
            valamelyik csomagunkra.
          </Typography>
          <Button
            variant='outlined'
            sx={{ mt: 2 }}
            onClick={() => toggleSubscriptions(!displaySubscriptionBoxes)}
          >
            {displaySubscriptionBoxes
              ? 'Előfizetési lehetőségek bezárása'
              : 'Előfizetési lehetőségek megtekintése'}
          </Button>
          {displaySubscriptionBoxes && <Subscriptions redirectToOrder />}
        </Box>
      )}
    </Box>
  );
}
